import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map } from 'rxjs';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  /** @description Cambia la visibilidad del navbar */
  private visible = new BehaviorSubject<boolean>(true);
  visible$ = this.visible.asObservable();
  setVisibility(visible: boolean) {
    this.visible.next(visible);
  }

  /** @description Modifica cualquier estado al que este suscrito */
  private changeState = new BehaviorSubject<boolean>(false);
  changeState$ = this.changeState.asObservable();
  setState(state: boolean) {
    this.changeState.next(state);
  }

  constructor(private readonly http: HttpClient) {}

  private url = environment.url;

  getNotificaciones(params: HttpParams) {
    const direction = this.url + 'notificaciones';
    return this.http.get<any>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result)
    );
  }

  updateNotificaciones(id: string, form: any) {
    const direction = this.url + 'notificaciones/' + id;
    return this.http.put<any>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result)
    );
  }
}
